import * as React from 'react'
import BrowserCheckLayout from './BrowserCheckLayout'
import Checks from './checks'

export default function App() {
    return (
        <BrowserCheckLayout title="Browser-Check">
            <Checks />
        </BrowserCheckLayout>
    )
}
